import $ from 'jquery';

export const showAfIntroModal = () => {
  const videoUrl = 'https://www.youtube.com/embed/9juQSK206Xg';
  $('#tryAnnunciFunebriVideo').attr(
    'src',
    videoUrl + '?autoplay=0&amp;modestbranding=1&amp;showinfo=0&rel=0'
  );
  $('#tryEternoVideo').data('src');
  $('#modalTryAnnunciFunebri').modal('show');
};
